<template>
  <div>
    <div class="row">
      <div class="col-lg"></div>
      <div class="col-lg-4">
        <card
          style="
            box-shadow: none;
            color: #A5A5A5;
            padding: 0px 0px 30px 30px;
            height: 630px;
            background-color: white;
          "
        >
          <p style="color: #358CCB; font-size: 24px; font-weight: 300">
            DELIVERY ORDER
          </p>

          <p class="subtitle">Delivery Report DO #7899</p>

          <!-- <p class="new-title">Job Reference No.</p>
          <p class="subtitle">{{ this.jobno }}</p> -->

          <p class="new-title">Time of Acceptance</p>
          <p class="subtitle">14:35</p>

          <p class="new-title">Lab Report</p>
          <!--downloadable-->
          <p class="report">labreport.pdf</p>

          <p class="new-title">Inspection Photos</p>
          <div class="row">
            <div class="col-lg"></div>
            <div v-for="item in inspectionphotos" :key="item" class="col-lg-3">
              <img :src="item" alt="Image" @click="enlargeImage(item)" />
              <div
                v-if="enlargedItem === item"
                class="enlarged-image"
                @click="closeEnlarged"
              >
                <img :src="item" alt="Enlarged Image" />
              </div>
            </div>
            <div class="col-lg"></div>
          </div>

          <div class="row text-center" style="margin-top: 100px">
            <div class="col-lg"></div>
            <base-button type="primary" v-on:click="getLogin()">
              <i
                style="color: white; font-size: 18px; font-weight: 900"
                class="tim-icons icon-cloud-download-93"
              ></i
              >&nbsp; Print</base-button
            >
            <div class="col-lg"></div>
          </div>
        </card>
      </div>
      <div class="col-lg"></div>
    </div>

    <div class="row">
      <div class="col-lg"></div>
      <div class="col-lg-3 text-right">
        <base-button type="danger" v-on:click="prevTab()">Back</base-button
        >&nbsp;

        <base-button

          type="primary"
          v-on:click="handleDone()"
          >Accept</base-button
        >
      </div>
    </div>
    <div class="row">
      <div class="col-lg"></div>
      <div class="col-lg-3 text-right">
        <!-- @click="saveDraft()" -->
        <base-button
          class="btn-link"
          style="color: #052d72; cursor: pointer; text-decoration: underline"
          disabled
        >
          Save Draft
      </base-button>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Option, Select, DatePicker } from "element-ui";
// import moment, { utc } from "moment";
import swal from "sweetalert2";
import { ImageUpload } from "src/components";

export default {
  props: ["parentData"],
  components: {
    ImageUpload,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
  },
  props: ["test1"],
  data() {
    return {
      enlarged: false,
      enlargedItem: null,

      specify: "",

      deliveryterm: "",
      paymentterm: "",

      jobno: "",
      inspectionphotos: [
        "img/login-bg-2.png",
        "img/login-bg.png",
        "img/login-bg-3.png",
      ],
      selects: {
        location: "",
        locations: [
          { value: 1, label: "Workshop Asia Port, CT1" },
          { value: 2, label: "Workshop Asia Port, CT1" },
          { value: 3, label: "Others (Please specify)" },
        ],

        pic: "",
        pics: [
          { value: 1, label: "Amirah binti Azman" },
          { value: 2, label: "Yahya Abd Rahman" },
          { value: 3, label: "Haziq Haikal bin Ayub" },
        ],
      },
    };
  },
  created() {},
  mounted() {
    this.jobno = this.$route.params.jobnum;
  },
  methods: {
    prevTab() {
      console.log("prev");
      let parameter = {
        step: "2",
        direction: "blkg",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    nextTab() {
      // console.log("next page")
      let parameter = {
        step: "2",
        direction: "depan",
        data: [],
      };
      this.$emit("my-event", parameter);
      // this.validateStep('step2')
    },

    
    enlargeImage(item) {
      this.enlargedItem = this.enlargedItem === item ? null : item;
    },
    closeEnlarged() {
      this.enlargedItem = null;
    },
    validate() {
      // if(this.imagebase64 == "" || this.images.regular == null){
      //     swal({
      //         title: "Data Error!",
      //         text: "All data must be filled in.",
      //         type: "warning",
      //         confirmButtonClass: "btn btn-success btn-fill",
      //         buttonsStyling: false,
      //     });
      // } else {
      return this.$validator.validateAll().then((res) => {
        this.$root.$emit("image", this.imagebase64);
        return res;
      });
      // }
    },
  },
};
</script>
<style scoped>
.new-title {
  margin-top: 20px;
  color: #A5A5A5;
}
.subtitle {
  color: #A5A5A5;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}

.report {
  color: #358CCB;
  text-decoration: none;
}
.report:hover {
  color: #358CCB;
  text-decoration: underline;
  cursor: pointer;
}

.enlarged-image {
  z-index: 9999;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}
.enlarged-image img {
  max-width: 80%;
  max-height: 80%;
  object-fit: contain;
}
</style>
